import { render } from "./CollectionIntegrationDataBase.vue?vue&type=template&id=16d0d86a&scoped=true"
import script from "./CollectionIntegrationDataBase.vue?vue&type=script&lang=js"
export * from "./CollectionIntegrationDataBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d0d86a"]])

export default __exports__